import { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import api from "../../api/axiosClient";

const RequireAdminAuth = ({ children }) => {
  const [status, setStatus] = useState("checking");

  useEffect(() => {
    api
      .get("admin/profile/")
      .then(() => setStatus("ok"))
      .catch(() => setStatus("denied"));
  }, []);

  if (status === "checking") {
    return (
      <div style={{
        display: "flex", alignItems: "center", justifyContent: "center",
        minHeight: "100vh", background: "#060607",
        color: "#555560", fontFamily: "DM Sans, sans-serif",
        fontSize: ".9rem", gap: 12,
      }}>
        <div style={{
          width: 18, height: 18,
          border: "2px solid #222",
          borderTop: "2px solid #FFD700",
          borderRadius: "50%",
          animation: "spin .7s linear infinite",
        }} />
        <style>{`@keyframes spin { to { transform: rotate(360deg) } }`}</style>
        Verifying access...
      </div>
    );
  }

  return status === "ok" ? children : <Navigate to="/admin-login" replace />;
};

export default RequireAdminAuth;